'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002eutil$002e$002dCollections$0024$002dUnmodifiable$002dCollection from "./java.util.-Collections$-Unmodifiable-Collection.js";
import * as $j_java$002eutil$002e$002dCollections$0024$002dUnmodifiable$002dList$002dIterator from "./java.util.-Collections$-Unmodifiable-List-Iterator.js";
var $p;
function $ct_ju_Collections$UnmodifiableList__ju_List__($thiz, inner) {
  $j_java$002eutil$002e$002dCollections$0024$002dUnmodifiable$002dCollection.$ct_ju_Collections$UnmodifiableCollection__ju_Collection__($thiz, inner);
  return $thiz;
}
export { $ct_ju_Collections$UnmodifiableList__ju_List__ as $ct_ju_Collections$UnmodifiableList__ju_List__ };
/** @constructor */
function $c_ju_Collections$UnmodifiableList() {
  this.fv = null;
}
export { $c_ju_Collections$UnmodifiableList as $c_ju_Collections$UnmodifiableList };
$p = $c_ju_Collections$UnmodifiableList.prototype = new $j_java$002eutil$002e$002dCollections$0024$002dUnmodifiable$002dCollection.$h_ju_Collections$UnmodifiableCollection();
$p.constructor = $c_ju_Collections$UnmodifiableList;
/** @constructor */
function $h_ju_Collections$UnmodifiableList() {
}
export { $h_ju_Collections$UnmodifiableList as $h_ju_Collections$UnmodifiableList };
$h_ju_Collections$UnmodifiableList.prototype = $p;
$p.fS = (function(index) {
  return this.fv.fS(index);
});
$p.f = (function(obj) {
  return this.fv.f(obj);
});
$p.m = (function() {
  return this.fv.m();
});
$p.Ct = (function(index, element) {
  throw $j_java$002elang$002e$002dObject.$ct_jl_UnsupportedOperationException__(new $j_java$002elang$002e$002dObject.$c_jl_UnsupportedOperationException());
});
$p.us = (function(index) {
  throw $j_java$002elang$002e$002dObject.$ct_jl_UnsupportedOperationException__(new $j_java$002elang$002e$002dObject.$c_jl_UnsupportedOperationException());
});
$p.C1 = (function() {
  return new $j_java$002eutil$002e$002dCollections$0024$002dUnmodifiable$002dList$002dIterator.$c_ju_Collections$UnmodifiableListIterator(this.fv.C1());
});
